const doc = [({"deals":({"or":"eller"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;